import { render, staticRenderFns } from "./SummaryDashboard.vue?vue&type=template&id=3d97d29e&scoped=true"
import script from "./SummaryDashboard.vue?vue&type=script&lang=ts"
export * from "./SummaryDashboard.vue?vue&type=script&lang=ts"
import style0 from "./SummaryDashboard.vue?vue&type=style&index=0&id=3d97d29e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d97d29e",
  null
  
)

export default component.exports